export const concatenateStrings = (stringsArray=[])=> stringsArray.join(' ').trim();
   